module.exports = __webpack_public_path__ + "static/media/mauricio.6f51662a.jpg";